
import { defineComponent } from 'vue'
import containerHeader from './components/container-header.vue'
import containerNav from './components/container-nav.vue'
import VersionUpdate from './components/dialog/version-update.vue'
import EsignContractDialog from './components/esign-contract-dialog/index.vue'
import store from '@/store'
import user from '../src/utils/user'
import { checkVersion, unCheckVersion } from '@/utils/version-check'
import { setEsignContractDialogInstance } from '@/utils/esign-contract'


export default defineComponent({
    name: 'Home',
    components: {
        containerHeader,
        containerNav,
        VersionUpdate,
        EsignContractDialog
    },
    data() {
        return {
            isNav: false,
            theme: {
                _text: 'red'
            },
            $store: store
        }
    },
    async created() {
        await user.waitLogin()
        store.commit('getLongPollingFile')
        console.log('获取环境', process.env.VUE_APP_BASE_URL)

        // 初始化版本检测
        this.initVersionCheck()
    },
    mounted() {
        // 设置签署合同弹框实例
        setEsignContractDialogInstance((this.$refs.esignContractDialogRef as any))
    },
    beforeUnmount() {
        // 组件销毁时停止版本检测
        unCheckVersion({ closeDialog: false, closeTimer: true })
    },
    methods: {
        onAdd() {
            store.commit('onModifyDownload')
        },
        // 清除版本检测相关的localStorage状态
        clearVersionCheckState() {
            console.log('清除版本检测localStorage状态')
            localStorage.removeItem('versionPrompt')
            localStorage.removeItem('ignored-version')
        },
        initVersionCheck() {
            console.log('初始化版本检测')

            checkVersion(
                {
                    pollingTime: 60000,
                    immediate: true,
                    enable: true,
                    onVersionUpdate: (data) => {
                        console.log('onVersionUpdate被调用', data)
                        // 备用方案确保弹窗显示
                        const event = new CustomEvent('showVersionDialog', {
                            detail: {
                                data: data,
                                options: {},
                                onRefresh: (data) => {
                                    console.log('用户选择更新版本:', data)
                                    window.location.reload()
                                },
                                onCancel: (data) => {
                                    console.log('用户取消更新版本:', data)
                                }
                            }
                        })
                        window.dispatchEvent(event)
                    },
                    onRefresh: (data) => {
                        console.log('用户选择更新版本:', data)
                        window.location.reload()
                    },
                    onCancel: (data) => {
                        console.log('用户取消更新版本:', data)
                    }
                },
            )
        }
    }

    // created () {}
})
